import React, { useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // Importation du style de Quill
import styled, { createGlobalStyle } from 'styled-components';
import { Text } from '../../atoms/Text';

// STYLES
import {
  colors,
  fontFamily,
  fontSize,
} from '../../../Design_System/DesignSystem';

interface AddPersonFormProps {
  setSelectedItem: React.Dispatch<React.SetStateAction<number>>;
}

// GlobalStyle pour personnaliser les styles de Quill
const GlobalStyle = createGlobalStyle`
  .ql-toolbar {
    border: 1px solid ${colors.tan} !important; /* Bordure de la barre d'outils */
  }
  .ql-container {
    border: 1px solid ${colors.tan} !important; /* Bordure de l'éditeur */
  }

  .ql-toolbar .ql-stroke {
    fill: none;
    stroke: tan;
}

.ql-toolbar .ql-fill {
    fill: tan;
    stroke: none;
}

.ql-toolbar .ql-picker {
    color: tan;
}
`;

const ArticleForm = ({ setSelectedItem }: AddPersonFormProps) => {
  const [title, setTitle] = useState<string>('');
  const [markdownContent, setMarkdownContent] = useState<string>(''); // Contenu de l'éditeur Quill
  const [loading, setLoading] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  // Configuration de la barre d'outils
  const modules = {
    toolbar: [
      [{ header: '1' }, { header: '2' }],
      [{ size: [] }],
      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
      [
        { list: 'ordered' },
        { list: 'bullet' },
        { indent: '-1' },
        { indent: '+1' },
      ],
      [{ direction: 'rtl' }],
      [{ size: ['small', false, 'large', 'huge'] }],
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ['link', 'image', 'video'],
      [{ align: [] }],
      ['clean'], // Supprime le formatage
    ],
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setErrorMessage(null);

    try {
      // Simulation d'une requête pour ajouter un article
      console.log('Article submitted:', { title, markdownContent });
      setTitle(''); // Réinitialiser le champ titre
      setMarkdownContent(''); // Réinitialiser le contenu Quill
      setSelectedItem(8);
    } catch (error) {
      setErrorMessage("Erreur lors de l'ajout de l'article.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <GlobalStyle />
      <AddArticleContainer>
        <TitleContainer>
          <Text
            color={colors.tan}
            fontSize={fontSize.smallTitle}
            fontFamily={fontFamily.tinos}
            bold={false}
            justify={false}
          >
            Ajouter un nouvel article
          </Text>
          <Title onClick={() => setSelectedItem(8)}>
            <Text
              color={colors.tan}
              fontSize={fontSize.small}
              fontFamily={fontFamily.tinos}
              bold={true}
              justify={false}
            >
              Retour
            </Text>
          </Title>
        </TitleContainer>

        <form onSubmit={handleSubmit}>
          <div>
            <label htmlFor="title">Titre :</label>
            <input
              type="text"
              id="title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              required
            />
          </div>

          <div>
            <label htmlFor="markdownContent">Contenu :</label>
            <ReactQuill
              theme="snow"
              value={markdownContent}
              onChange={setMarkdownContent}
              modules={modules}
            />
          </div>

          <button type="submit" disabled={loading}>
            {loading ? 'Ajout en cours...' : 'Ajouter un article'}
          </button>
        </form>

        {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
      </AddArticleContainer>
    </>
  );
};

const AddArticleContainer = styled.div`
  color: ${colors.tan};
  margin: 20px;
`;

const Title = styled.div`
  cursor: pointer;
`;

const TitleContainer = styled.div`
  display: flex;
  overflow: hidden; /* Pour éviter le débordement */
  justify-content: space-between;
  align-items: flex-end;
`;

export default ArticleForm;
